<template>
    <b-card>
        <!-- for loading page -->
        <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
        <div class="col-sm-12">
            <h4 class="h4-title">{{pageTitle}}</h4>
            <form>
                <b-row>
                  <b-col class="form-group">
                    <label>Background</label>&nbsp;&nbsp;&nbsp;<font class="hint">Recommended size 420 * 80, 940 * 160 (width * height)</font>
                    <div class="divbackground" v-show="projectProfile.background">
                      <b-img :src="projectProfile.background" alt="" class="form-control nopadding"></b-img>
                        <b-button
                      variant="danger"
                      class="btn b-btn action-b-btn delete-b-btn deleteBackgroundBtn"
                      v-b-tooltip.hover
                      :title="text.deleteBackground"
                      v-if="editMode"
                      @click="deleteBackground"
                      >
                      {{text.deleteBackground}}
                      </b-button>
                    </div>
                    <div>
                      <b-form-file class="form-control" v-model="newBackground" @change="processFileInput"  accept=".jpg, .png, .gif"></b-form-file>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    class="form-group"
                    cols="4"
                >
                    <label for="formGroupExampleInput">{{text.code}}</label>
                    <label class="form-control" v-if="editMode">{{ projectProfile.code }}</label>
                    <input
                    type="text"
                    class="form-control"
                    id="code"
                    :placeholder="text.code"
                    v-model="projectProfile.code"
                    required
                    v-if="!editMode"
                    >
                </b-col>
                <b-col
                    class="form-group"
                    cols="4"
                >
                    <label for="formGroupExampleInput">{{text.name}}</label>
                    <input
                    type="text"
                    class="form-control"
                    id="name"
                    :placeholder="text.name"
                    v-model="projectProfile.name"
                    required
                    >
                </b-col>
                 <b-col
                    class="form-group"
                    cols="4"
                >
                    <label for="formGroupExampleInput">{{text.contactEmail}}</label>
                     <input
                    type="text"
                    class="form-control"
                    id="contactEmail"
                    :placeholder="text.contactEmail"
                    v-model="projectProfile.contactEmail"
                    required
                    >
                </b-col>
                <b-col
                    class="form-group"
                    cols="4"
                >
                    <label for="formGroupExampleInput">{{text.phoneNumber}}</label>
                    <the-mask id="phoneNumber" class="form-control" :mask="['###-###-####']" v-model="projectProfile.phoneNumber" :masked="false" type="tel" placeholder="xxx-xxx-xxxx" />
                </b-col>
                <b-col
                      class="form-group"
                      cols="4"
                  >
                      <label for="formGroupExampleInput">{{text.juristicNumber}}</label>
                      <the-mask id="juristicNumber" class="form-control" :mask="['###-###-####']" v-model="projectProfile.juristicNumber" :masked="false" type="tel" placeholder="xxx-xxx-xxxx" />
                </b-col>
                </b-row>
                <b-row v-if="editable">
                <div class="col-sm-2 col-200">
                    <button
                    type="button"
                    class="btn action-b-btn b-btn"
                    :disabled="isUpdating"
                    @click="saveProject"
                    >
                    <b-spinner
                        small
                        v-if="isUpdating"
                    ></b-spinner>
                    {{text.save}}
                    </button>
                </div>
                <div class="col-sm-2 col-100">
                    <b-button
                    variant="danger"
                    class="btn b-btn action-b-btn delete-b-btn"
                    v-b-tooltip.hover
                    :title="text.deleteProject"
                    v-if="editMode"
                    @click="deleteProject"
                    >
                    {{text.deleteProject}}
                    </b-button>
                </div>
                </b-row>
                <hr />
                <div>
                <div class="form-group row">
                    <div class="col-lg-12">
                    <b-alert
                        variant="success"
                        dismissible
                        fade
                        :show="saveDone"
                    >
                        {{saveSuccessMessage}}
                    </b-alert>
                    <b-alert
                        variant="danger"
                        dismissible
                        fade
                        :show="saveError"
                    >
                        {{errorMessage}}
                    </b-alert>
                    </div>
                </div>
                </div>
            </form>
        </div>
    </b-card>
</template>
<script>
import { textProject } from '../../assets/utils/language';
import MqdcOneClient from '@/models/mqdc-one-client';
import { TheMask } from 'vue-the-mask';
import { PNF, phoneUtil } from '@/assets/utils/phone-util';
import Loading from '@/components/Loading';

export default {
  name: 'Project',
  props: ['code'],
  data () {
    return {
      projectProfile: {
        name: '',
        code: '',
        background: '',
        phoneNumber: '',
        juristicNumber: '',
        contactEmail: '',
        createdAt: '',
        updatedAt: ''
      },
      fields: [],
      selectedProject: null,
      projects: [],
      residentProjects: [],
      saveDone: false,
      saveError: false,
      isUpdating: false,
      editMode: false,
      editable: true,
      isLoading: false,
      saveSuccessMessage: '',
      updateSuccessMessage: '',
      deleteProjectWarning: 'Are you sure to delete this Project?',
      deleteProjectSuccess: 'Deleted Project successfully.',
      confirmMessage: '',
      successMessage: '',
      errorMessage: '',
      verifyBtnCaption: 'Verify',
      pageTitle: 'Project',
      mqdcOneClient: {},
      confirmBoxOptions: {
        title: 'Please confirm!',
        text: '',
        type: 'question',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#339DAA',
        cancelButtonText: 'No',
        cancelButtonColor: '#d33',
        width: 500,
        animation: true,
        padding: '3em',
        background: '#fff'
      },
      alertBoxOptions: {
        confirmButtonColor: '#339DAA'
      },
      text: {},
      newBackground: null,
      projectsUrl: `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/projects`
    };
  },
  mounted () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    this.text = textProject(this.$language);
    this.saveSuccessMessage = this.text.saveSuccessMessage;
    this.updateSuccessMessage = this.text.updateSuccessMessage;
    this.deleteProjectWarning = this.text.deleteProjectWarning;
    this.deleteProjectSuccess = this.text.deleteProjectSuccess;
    this.confirmMessage = this.text.pleaseConfirm;
    if (this.code) {
      this.getProject();
      this.editMode = true;
      this.pageTitle = this.text.editProject;
    } else {
      this.editMode = false;
      this.pageTitle = this.text.newProject;
    }
  },
  methods: {
    processFileInput (e) {
      this.newBackground = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    },
    async getProject () {
      try {
        this.isLoading = true;
        const url = `${this.projectsUrl}/${this.code}`;
        const projectProfile = await this.mqdcOneClient.getAxios().then(axios => {
          return axios.get(url);
        });
        this.projectProfile = projectProfile.data.data;
        this.editMode = true;
        this.isLoading = false;
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    saveProject () {
      if (this.editMode) {
        this.updateProject();
      } else if (false === this.editMode) {
        this.createProject();
      }
    },
    updateProject () {
      const projectPatch = {
        'name': this.projectProfile.name,
        'phoneNumber': this.projectProfile.phoneNumber,
        'juristicNumber': this.projectProfile.juristicNumber,
        'contactEmail': this.projectProfile.contactEmail
      };
      try {
        this.isUpdating = true;
        const url = `${this.projectsUrl}/${this.code}`;
        this.mqdcOneClient.getAxios().then(axios => {
          axios.patch(url, projectPatch).then(response => {
            this.saveDone = true;
            this.successMessage = this.updateSuccessMessage;
            if (this.newBackground) {
              this.isLoading = true;
              this.addProjectBackground(this.projectsUrl, axios).then(response => {
                this.getProject();
                this.$alert(this.updateSuccessMessage, 'Success', 'success', this.alertBoxOptions).then(() => { });
                this.isUpdating = false;
              }).catch(error => {
                console.log('Image update error: ', error);
              });
            } else {
              this.getProject();
              this.$alert(this.updateSuccessMessage, 'Success', 'success', this.alertBoxOptions).then(() => { });
              this.isUpdating = false;
            }
          }).catch(error => {
            this.saveError = true;
            this.saveDone = false;
            this.successMessage = '';
            this.errorMessage = error.response.data.message;
            this.$alert(`${error.response.data.message}`, 'Error', 'error').then(() => { });
            console.log(error.response);
            this.isUpdating = false;
            this.isLoading = false;
          });
        });
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    addProjectBackground (url, axios) {
      const newBackgroundUrl = `${url}/${this.projectProfile.code}/background`;
      const backgroundFd = new FormData();
      backgroundFd.append('background', this.newBackground);
      return axios.post(newBackgroundUrl, backgroundFd);
    },
    deleteBackground () {
      this.confirmBoxOptions.text = this.confirmMessage;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          try {
            this.mqdcOneClient.getAxios().then(axios => {
              const backgroundUrl = `${this.projectsUrl}/${this.projectProfile.code}/background`;
              axios.delete(backgroundUrl).then(response => {
                this.newBackground = null;
                this.getProject();
              }).catch(error => {
                console.log('Image update error: ', error);
              });
            });
          } catch (err) {
            console.log('Error ===>>>', err);
          }
        }
      });
    },
    createProject () {
      const projectCreate = {
        'name': this.projectProfile.name,
        'code': this.projectProfile.code,
        'phoneNumber': this.projectProfile.phoneNumber,
        'juristicNumber': this.projectProfile.juristicNumber,
        'contactEmail': this.projectProfile.contactEmail
      };
      try {
        this.isUpdating = true;
        this.isLoading = true;
        const url = this.projectsUrl;
        this.mqdcOneClient.getAxios().then(axios => {
          axios.post(url, projectCreate).then(response => {
            this.saveDone = true;
            this.successMessage = this.saveSuccessMessage;
            this.isUpdating = false;
            if (this.newBackground) {
              this.addProjectBackground(url, axios).then(response => {
                this.isLoading = false;
                this.$alert(this.saveSuccessMessage, 'Success', 'success', this.alertBoxOptions).then(() => {
                  this.redirectToEdit(this.projectProfile.code);
                });
              }).catch(error => {
                console.log('Image update error: ', error);
              });
            }
            this.isLoading = false;
            this.$alert(this.saveSuccessMessage, 'Success', 'success', this.alertBoxOptions).then(() => {
              this.redirectToEdit(this.projectProfile.code);
            });
          }).catch(error => {
            this.saveError = true;
            this.saveDone = false;
            this.successMessage = '';
            this.errorMessage = error.response.data.message;
            this.$alert(`${error.response.data.message}`, 'Error', 'error').then(() => { });
            console.log(error.response);
            this.isUpdating = false;
          });
        });
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    deleteProject () {
      this.confirmBoxOptions.text = this.confirmMessage;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          try {
            const url = `${this.projectsUrl}/${this.code}`;
            this.mqdcOneClient.getAxios().then(axios => {
              axios.delete(url).then(response => {
                this.$alert(this.deleteProjectSuccess, 'Success', 'success', this.alertBoxOptions).then(() => {
                  this.$router.push({ name: 'one_app_projects' });
                });
              })
                .catch(error => {
                  console.log('Delete Err ===> ', error);
                });
            });
          } catch (err) {
            console.log('Error ===>>>', err);
          }
        }
      });
    },
    redirectToEdit (code) {
      const editUrl = this.$router.resolve({ name: 'one_app_projects-project', params: { code: code } }).href;
      document.location = editUrl;
    }
  },
  computed: {
    mobileText () {
      if (this.projectProfile.phoneNumber) {
        return phoneUtil.format(phoneUtil.parseAndKeepRawInput(this.projectProfile.phoneNumber, 'TH'), PNF.NATIONAL);
      } else if (this.projectProfile.juristicNumber) {
        return phoneUtil.format(phoneUtil.parseAndKeepRawInput(this.projectProfile.juristicNumber, 'TH'), PNF.NATIONAL);
      } else {
        return null;
      }
    }
  },
  components: {
    TheMask,
    'app-loading': Loading
  }
};
</script>
<style scoped src="@/assets/css/userprofile.css"></style>
<style scoped src="@/assets/css/project.css"></style>
